import type { Margins, SpatialRectangle } from "#public"
import type { Measure } from "#public"
import { ToMargins } from "#public"

/**
 * Expand a rect by edge margins; `sign=-1` shrinks it instead — see
 * {@link RemoveMargins}.
 *
 * Mirrors Python `pyfuncs.objects.measure.functions.add_margins`
 * (functions.py:52-57) — but `y` grows up here, so the edge that moves the
 * origin is `bottom`, where the y-down original moved it by `top`.
 */
export const AddMargins = <T extends Measure>(
  { x, y, width, height }: SpatialRectangle<T>,
  margins: T | Margins<T> = 0 as T,
  sign: 1 | -1 = 1
): SpatialRectangle<T> => {
  const { top, right, bottom, left } = ToMargins(margins)
  return {
    x: (x - left * sign) as T,
    y: (y - bottom * sign) as T,
    width: (width + (left + right) * sign) as T,
    height: (height + (top + bottom) * sign) as T,
  }
}
